import { insightAreaUpdateFilterCriteria } from "../../../actions/insight-area-actions"

import InsightAreaFilterForm from "./InsightAreaFilterForm"

import buildItemConnector from "../../common/build-item-connector"

export default buildItemConnector(
    "insightAreas",
    true,
    insightAreaUpdateFilterCriteria
)(InsightAreaFilterForm)
